import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * A checkbox allows a user to select a value from a small set of options, often binary.
 */
const CheckBox = (props) => {
  const { className, label, id, ...otherProps } = props;
  const classNames = classnames('form-checkbox', className);

  return (
    <label htmlFor={id} className={classNames}>
      <input id={id} {...otherProps} type="checkbox" />
      <i className="form-icon" /> {label}
    </label>
  );
};

CheckBox.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Optional Label to display along side the CheckBox. */
  label: PropTypes.any,
  /** Input id */
  id: PropTypes.string,
};

CheckBox.defaultProps = {
  className: '',
  label: '',
  id: '',
};

export { CheckBox };
